import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {NotificationManager} from '../../../../components/common/react-notifications';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {i18nizeDate, mask} from '../../../../helpers/Utils';
import BankAccountDetails from '../../../../containers/BankAccountDetails';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import {keyBy, mapValues, omit} from 'lodash';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';
import moment from 'moment';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bankAccounts: [],
      pages: -1,
      loading: false,
      refreshing: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
    };
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  fetchBankAccounts = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users-bank-accounts',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            status: 'Pending',
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {from: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {to: moment(this.state.selectedEndDate).toISOString()} : null),
          }
        });
      this.setState({
        bankAccounts: data.accounts,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchBankAccounts(state);
    this.setState({loading: false});
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  getColumns = t => [
    {
      Header: t('First Name'),
      accessor: 'firstName',
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>
        {props.original.legalFirstName ?
          `${props.original.legalFirstName} (${t('legal')})` :
          `${props.value} (${t('profile')})`
        }
      </span>
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
      Filter: ReactTableTextFilter,
      Cell: props => <span>
        {props.original.legalLastName ?
          `${props.original.legalLastName} (${t('legal')})` :
          `${props.value} (${t('profile')})`
        }
      </span>,
      filterable: true,
    },
    {
      Header: t('Account Number'),
      accessor: 'accountNumber',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 140,
    },
    {
      Header: t('Card Number'),
      accessor: 'cardNumber',
      width: 150,
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{mask(props.value, '####-####-####-####')}</span>,
    },
    {
      Header: t('National Account Number'),
      accessor: 'nationalAccountNumber',
      width: 200,
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.value ? `IR${props.value}` : null}</span>,
    },
    {
      Header: t('Register Date'),
      accessor: 'createdAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 140,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('View'),
      width: 60,
      Cell: props => <Link to={{
        pathname: '/dashboard/users/' + props.original.userId,
        state: {
          section: 'Bank Accounts',
          accountNumber: props.original.accountNumber,
        },
      }}
      > <i className="simple-icon-eye view-icon"/> </Link>,
    },
  ];

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  updateList = (values, index) => {
    const {bankAccounts} = this.state;
    let list = [...bankAccounts];
    list.splice(index, 1, {...bankAccounts[index], ...values});
    this.setState({bankAccounts: list});
  };

  refreshList = async () => {
    const {t} = this.props;
    this.setState({refreshing: true});
    await this.fetchData(this.table.state);
    this.setState({refreshing: false});
    NotificationManager.info(t('Bank accounts list updated successfully'), t('Message'));
  };

  render() {
    const {t, match} = this.props;
    const {bankAccounts, pages, expanded, loading, refreshing} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="d-flex flex-row justify-content-end align-items-center">
                  <Button
                    outline
                    disabled={refreshing || loading}
                    className="d-flex align-items-center justify-content-center"
                    onClick={this.refreshList}>
                    <i className='icon-File-Refresh text-large'/>
                    <span className="mx-1">{t('Refresh')}</span>
                  </Button>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={bankAccounts}
                  pages={pages}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  expanded={expanded}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  onExpandedChange={this.onExpanded}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={row =>
                    <BankAccountDetails
                      itemIndex={row.index}
                      bankAccount={row.original}
                      updateList={this.updateList}
                    />
                  }
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
